export function domContentLoadEvent(fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(fn); //next tick
        });
    } else {
        fn();
    }
}
